import React from 'react';
import TypeChips from './components/TypeChips';
import RangeSliderWithInputs from './components/RangeSliderWithInputs';
import LocationPicker from './components/LocationPicker';
import AdvancedDrawer from './components/AdvancedDrawer';

const PROPERTY_TYPES = [
    { value: 'flat', label: 'Flat' },
    { value: 'villa', label: 'Villa' },
    { value: 'commercial', label: 'Commercial' },
];

export default function IntentRentForm({ data, onChange }) {
    const updateBasics = (field, value) => onChange('basics', field, value);
    const updateBudget = (field, value) => onChange('budget', field, value);
    const updateSpecs = (field, value) => onChange('specifications', field, value);

    const { basics = {}, budget = {}, specifications = {}, advanced = {} } = data;

    return (
        <div className="req-grid">
            <div className="req-col-span-2">
                <h3 className="req-section-title">Rent Requirements</h3>
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Property Types</label>
                <TypeChips
                    options={PROPERTY_TYPES}
                    value={basics.propertyTypes || []}
                    onChange={(val) => updateBasics('propertyTypes', val)}
                />
            </div>

            <div className="req-col-span-2">
                <LocationPicker
                    city={basics.city}
                    localities={basics.localities}
                    onChange={updateBasics}
                />
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Pincode</label>
                <input
                    type="text"
                    className="req-input"
                    placeholder="e.g. 560001"
                    value={basics.pincode || ''}
                    onChange={(e) => updateBasics('pincode', e.target.value)}
                />
            </div>

            <div className="req-col-span-2">
                <h3 className="req-section-title" style={{ marginTop: '12px' }}>Budget & Terms</h3>
            </div>

            <RangeSliderWithInputs
                label="Monthly Rent"
                valueMin={budget.min}
                valueMax={budget.max}
                onChange={({ min, max }) => {
                    updateBudget('min', min);
                    updateBudget('max', max);
                }}
                unit="INR/month"
            />

            <div className="req-field">
                <label className="req-label">Move-in Date</label>
                <input
                    type="date"
                    className="req-input"
                    value={specifications.moveInDate || ''}
                    onChange={(e) => updateSpecs('moveInDate', e.target.value)}
                />
            </div>

            <div className="req-field">
                <label className="req-label">Furnishing</label>
                <select
                    className="req-input"
                    value={specifications.furnishing || 'any'}
                    onChange={(e) => updateSpecs('furnishing', e.target.value)}
                >
                    <option value="any">Any</option>
                    <option value="unfurnished">Unfurnished</option>
                    <option value="semi">Semi-Furnished</option>
                    <option value="fully">Fully Furnished</option>
                </select>
            </div>

            <div className="req-col-span-2">
                <AdvancedDrawer>
                    <div className="req-field">
                        <label className="req-label">Lease Term</label>
                        <select
                            className="req-input"
                            value={advanced.leaseTerm || '11m'}
                            onChange={(e) => onChange('advanced', 'leaseTerm', e.target.value)}
                        >
                            <option value="11m">11 Months</option>
                            <option value="2y">2 Years</option>
                            <option value="3y">3 Years</option>
                            <option value="5y+">5+ Years</option>
                        </select>
                    </div>
                </AdvancedDrawer>
            </div>
        </div>
    );
}
